// esri.core
import { property, subclass } from "@arcgis/core/core/accessorSupport/decorators";
import Accessor from "@arcgis/core/core/Accessor";
import Handles from "@arcgis/core/core/Handles";

import GlobalNav from "../../widgets/GlobalNav/GlobalNav";
import Portal from 'src/app/utils/Portal/Portal';
import { whenDefinedOnce } from '@arcgis/core/core/watchUtils';
import Logo from "../../../../public/assets/images/arcgis-instant-apps-96.png";

export interface InstantAppLandingViewModelProperties extends __esri.WidgetProperties {
  portal: Portal;
  appConfig: any;
}

@subclass("Landing.ui.InstantAppLanding.InstantAppLandingViewModel")
export default class InstantAppLandingViewModel extends Accessor {
  // ----------------------------------
  //
  //  Public Variables
  //
  // ----------------------------------

  @property()
  portal: Portal;

  @property()
  appConfig: any;

  @property()
  appMessages;

  @property()
  globalNavMessages;

  // ----------------------------------
  //
  //  Private Variables
  //
  // ----------------------------------
  private _handles: Handles = new Handles();
  private _globalNavUtil: any;

  // ----------------------------------
  //
  //  Lifecycle methods
  //
  // ----------------------------------
  constructor(params: InstantAppLandingViewModelProperties) {
    super(params);
  }

  initialize() {
  }

  // createGlobalNav
  async createGlobalNav(): Promise<void> {
    whenDefinedOnce(this, "globalNavMessages", async () => {
      this._globalNavUtil = new GlobalNav({
        appConfig: this.appConfig,
        portal: this.portal,
        globalNavMessages: this.globalNavMessages
      });
    })

    whenDefinedOnce(this, "appMessages", async () => {
      whenDefinedOnce(this, "globalNavMessages", async () => {
        await this._globalNavUtil.createHeader("Instant Apps", Logo);
      });
    })
  }



}